// import CryptoJS from "crypto-js";
// // Example: entire clientId as the key:
// const CLIENT_ID = "qv678BrOfw7apgYrAw5LpVJGuvtuDE0H";
// export function encryptAES(plainText) {
//   const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
//   // last 16 characters for IV
//   const ivString = CLIENT_ID.slice(-16);
//   const iv = CryptoJS.enc.Utf8.parse(ivString);
//   const encrypted = CryptoJS.AES.encrypt(
//     CryptoJS.enc.Utf8.parse(plainText),
//     key,
//     {
//       iv: iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7,
//     }
//   );
//   return encrypted.toString(); // Base64
// }
// export function decryptAES(encryptedText) {
//   const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
//   const ivString = CLIENT_ID.slice(-16);
//   const iv = CryptoJS.enc.Utf8.parse(ivString);
//   const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   return decrypted.toString(CryptoJS.enc.Utf8);
// }

import CryptoJS from "crypto-js";
// Example: entire clientId as the key:
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID; // from apg
export function encryptAES(plainText) {
  const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
  // last 16 characters for IV
  const ivString = CLIENT_ID.slice(-16);
  const iv = CryptoJS.enc.Utf8.parse(ivString);
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString(); // Base64
}
export function decryptAES(encryptedText) {
  const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
  const ivString = CLIENT_ID.slice(-16);
  const iv = CryptoJS.enc.Utf8.parse(ivString);
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export function decryptUpload(encryptedText) {
  const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
  const ivString = CLIENT_ID.slice(-16);
  const iv = CryptoJS.enc.Utf8.parse(ivString);
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(decrypted);
}

// ---- helpers ----
// --- HELPER FUNCTIONS ---

// Converts a CryptoJS WordArray to a Uint8Array (raw bytes)
function wordArrayToUint8Array(wordArray) {
  const len = wordArray.sigBytes;
  const u8 = new Uint8Array(len);
  let offset = 0;
  for (let i = 0; i < wordArray.words.length; i++) {
      let word = wordArray.words[i];
      for (let j = 3; j >= 0 && offset < len; j--) {
          u8[offset++] = (word >> (8 * j)) & 0xff;
      }
  }
  return u8;
}

// Converts a base64 string to a Uint8Array (raw bytes)
function base64ToUint8Array(b64) {
  const bin = atob(b64.replace(/\s+/g, ""));
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
      out[i] = bin.charCodeAt(i);
  }
  return out;
}

// Sniffs the "magic bytes" at the start of a file to determine its MIME type
function sniffMime(bytes) {
  if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return "image/jpeg";
  if (bytes.length >= 8 && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) return "image/png";
  if (bytes.length >= 3 && bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46) return "image/gif";
  if (bytes.length >= 12 && bytes[0] === 0x52 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x46 &&
      bytes[8] === 0x57 && bytes[9] === 0x45 && bytes[10] === 0x42 && bytes[11] === 0x50) return "image/webp";
  return null;
}


// --- MAIN DECRYPTION FUNCTION ---
// This is the only function you need to export and call from your component.
// It is now an async function because it uses FileReader.

export async function decryptToDataURL(ciphertextB64) {
  // 1. Validate input to prevent the crash. This is a basic check.
  if (typeof ciphertextB64 !== 'string') {
      throw new Error("Invalid input to decryptToDataURL: Expected a string.");
  }
  
  // 2. Fix a common transport issue where '+' becomes a space.
  const safeCipher = ciphertextB64.replace(/ /g, "+");

  // 3. Decrypt the data.
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CLIENT_ID); // Use your environment variable
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CLIENT_ID.slice(-16));
  const wa = CryptoJS.AES.decrypt(safeCipher, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  });

  // 4. Convert the decrypted result into raw bytes (Uint8Array).
  let bytes = wordArrayToUint8Array(wa);

  // 5. Heuristic: Check if the decrypted content is *itself* a base64 string.
  // This makes the function robust if the backend changes its output format.
  const base64Charset = (b) => b === 10 || b === 13 || b === 61 || (b >= 43 && b <= 122 && "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".includes(String.fromCharCode(b)));
  const score = bytes.reduce((a, b) => a + (base64Charset(b) ? 1 : 0), 0) / Math.max(bytes.length, 1);
  if (score > 0.95) {
      const text = new TextDecoder("utf-8").decode(bytes).replace(/\s+/g, "");
      bytes = base64ToUint8Array(text);
  }

  // 6. Determine the image type and create a Blob.
  const mime = sniffMime(bytes);
  if (!mime) {
      console.error("Decryption produced non-image bytes. First 16:", Array.from(bytes.slice(0, 16)));
      throw new Error("Decryption yielded non-image data. Check server response or encryption key.");
  }
  const blob = new Blob([bytes], { type: mime });

  // 7. Use FileReader to convert the robust Blob into a persistent data: URL.
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
  });
}